import { render, staticRenderFns } from "./ClaimsGraphs.vue?vue&type=template&id=0b55ff4a&scoped=true"
import script from "./ClaimsGraphs.vue?vue&type=script&lang=ts"
export * from "./ClaimsGraphs.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsGraphs.vue?vue&type=style&index=0&id=0b55ff4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b55ff4a",
  null
  
)

export default component.exports